import type { LeadSummary } from 'app/features/leads/services/gym-finder/types';

// Mixed statuses + dates so the table can demo filtering, search, and newest-first ordering
// end-to-end against the mocked Gym Finder service.
export const LEADS_FIXTURES: LeadSummary[] = [
  {
    id: 'lead-1',
    athleteName: 'Alex Morgan',
    athleteEmail: 'alex.morgan@example.com',
    enquiryType: 'Session request',
    status: 'active',
    receivedAt: '2026-05-20T09:30:00.000Z',
    message: 'Hi, I would like to book an intro session at your gym.',
  },
  {
    id: 'lead-2',
    athleteName: 'Jordan Lee',
    athleteEmail: 'jordan.lee@example.com',
    enquiryType: 'General enquiry',
    status: 'paused',
    receivedAt: '2026-05-19T14:15:00.000Z',
    message: 'Could you share your class schedule and pricing?',
  },
  {
    id: 'lead-3',
    athleteName: 'Sam Taylor',
    athleteEmail: 'sam.taylor@example.com',
    enquiryType: 'Trial visit',
    status: 'trial',
    receivedAt: '2026-05-18T11:00:00.000Z',
    message: 'I am interested in trying a HYROX class this week.',
  },
  {
    id: 'lead-4',
    athleteName: 'Riley Chen',
    athleteEmail: 'riley.chen@example.com',
    enquiryType: 'Session request',
    status: 'active',
    receivedAt: '2026-05-17T16:45:00.000Z',
    message: 'Looking for coaching ahead of my first race.',
  },
  {
    id: 'lead-5',
    athleteName: 'Casey Patel',
    athleteEmail: 'casey.patel@example.com',
    enquiryType: 'Trial visit',
    status: 'trial',
    receivedAt: '2026-05-16T08:05:00.000Z',
    message: 'Can I book a trial class on Saturday?',
  },
  {
    id: 'lead-6',
    athleteName: 'Morgan Reed',
    athleteEmail: 'morgan.reed@example.com',
    enquiryType: 'Membership',
    status: 'paused',
    receivedAt: '2026-05-15T12:25:00.000Z',
    message: 'I would like to pause my enquiry while I travel.',
  },
];
